import { useSyncExternalStore } from 'react';
import { Library } from './library';

/** Process-wide singleton — initialised once in main.tsx. */
export const library = new Library();

/** Subscribe a component to library mutations. Returns the singleton. */
export function useLibrary(): Library {
  useSyncExternalStore(library.subscribe, library.getVersion, library.getVersion);
  return library;
}
